import React from 'react';
import LoginForm from '../../components/auth/LoginForm';

const LoginPage = () => {
  return <LoginForm key="stable-login-form" />;
};

export default LoginPage; 